import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";

export function PlaceImageCarousel({
  photos,
  alt,
}: {
  photos?: google.maps.places.Photo[];
  alt: string;
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  if (!photos || photos.length === 0) return null;

  const currentPhotoUrl = photos[currentIndex]?.getURI({ maxWidth: 300 });
  const showDots = photos.length > 1;

  return (
    <Box
      sx={{
        position: "relative",
        width: { xs: "80px", sm: "100px", lg: "150px" },
        height: { xs: "80px", sm: "100px", lg: "150px" },
        borderRadius: 1,
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src={currentPhotoUrl}
        alt={alt}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      {showDots && !isMobileScreen && (
        <Box
          sx={{
            position: "absolute",
            bottom: 4,
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: 0.5,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            borderRadius: "12px",
            px: 1,
            py: 0.25,
          }}
        >
          {photos.slice(0, 5).map((_, index) => (
            <IconButton
              key={index}
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setCurrentIndex(index);
              }}
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor:
                  index === currentIndex ? "white" : "rgba(255, 255, 255, 0.5)",
                p: 0,
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
